import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { PiTagSimpleLight, PiTagSimpleFill  } from "react-icons/pi";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { IoIosArrowForward } from "react-icons/io";
import { RxCross1 } from "react-icons/rx";


function MovePassword(props) {

  const [addFolderModal, setAddFolderModal] = useState(false);

  const addFoldertoggle = () => setAddFolderModal(!addFolderModal);

  return (
    <>
    <Modal
      isOpen={props.moveModal}
      toggle={props.moveModaltoggle}
      size="md"
      centered
    >
      <ModalHeader toggle={props.moveModaltoggle}>
        Move Password
      </ModalHeader>
      <ModalBody>
        <div className="locationWrp">
          <span>Location</span>
          Created
        </div>
        <div className="suggestionWrp">
          <h4>Suggested</h4>
          <ul>
            <li><PiTagSimpleLight style={{color:'#6E7898'}} /> Development_1 <HiOutlineDotsVertical className="dotMenu" /> <IoIosArrowForward className="arrow" /><span>Move</span></li>
            <li><PiTagSimpleFill style={{color:'#FF99C8'}} /> Development_1 <HiOutlineDotsVertical className="dotMenu" /> <IoIosArrowForward className="arrow" /><span>Move</span></li>
            <li><PiTagSimpleFill style={{color:'#D1F4DE'}} />Development_1 <HiOutlineDotsVertical className="dotMenu" /> <IoIosArrowForward className="arrow" /><span>Move</span></li>
            <li><PiTagSimpleFill style={{color:'#A8DEF8'}} />Development_1 <HiOutlineDotsVertical className="dotMenu" /> <IoIosArrowForward className="arrow" /><span>Move</span></li>
            <li><PiTagSimpleFill style={{color:'#A8DEF8'}} />Development_1 <HiOutlineDotsVertical className="dotMenu" /> <IoIosArrowForward className="arrow" /><span>Move</span></li>
            <li><PiTagSimpleFill style={{color:'#E4C1F9'}} />Development_1 <HiOutlineDotsVertical className="dotMenu" /> <IoIosArrowForward className="arrow" /><span>Move</span></li>
            <li><PiTagSimpleFill style={{color:'#F15C75'}} />Development_1 <HiOutlineDotsVertical className="dotMenu" /> <IoIosArrowForward className="arrow" /><span>Move</span></li>
            <li><PiTagSimpleFill style={{color:'#857ACF'}} />Development_1 <HiOutlineDotsVertical className="dotMenu" /> <IoIosArrowForward className="arrow" /><span>Move</span></li>
          </ul>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={addFoldertoggle}>
          Move
        </Button>
        <Button color="outline" onClick={props.moveModaltoggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>

    <Modal
      isOpen={addFolderModal}
      toggle={addFoldertoggle}
      size="md"
      centered
    >
      <ModalHeader toggle={addFoldertoggle}>
        Add New Folder
      </ModalHeader>
      <ModalBody>
        <form className="formWrap">
          <div className="formElmWrap">
            <Input
            id=""
            name=""
            placeholder="Enter Folder Name"
            type="text"
            />
          </div>
          <div className="colorPanel">
            <div className="colorTitle">
              <h4>Add Label Color</h4>
              <span className="removeColor">Remove Color</span>
              <ul className="colorList">
                <li className="blank"><RxCross1 /></li>
                <li className="color1"></li>
                <li className="color2"></li>
                <li className="color3"></li>
                <li className="color4"></li>
                <li className="color5"></li>
                <li className="color6"></li>
                <li className="color7"></li>
                <li className="color8"></li>
                <li className="color9"></li>
                <li className="color10"></li>
                <li className="color11"></li>
              </ul>
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={addFoldertoggle}>
          Move
        </Button>
        <Button color="outline" onClick={addFoldertoggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
    </>
  );
}

export default MovePassword;
